import { IOptionGroupItem } from '../../types';
import { IMenuItem, IOptionGroup } from '../../../../types/menu.types';

/***
 * Returns unique array of options that can be selected by the user in a modifier group.
 * infinite scroll on items means an option groups items must also be included in the list to be selectable
 * @param {Omit<IMenuItem, 'prices'>[]} items Array of items from the menu or from the product library -
 * pricing isn't read here, since a candidate item's price is always discarded on selection anyway
 * @param {IOptionGroup} [optionGroup] optional option group that is being edited
 * @return {IOptionGroupItem[]} array of items that can be selected by the user
 * */
export const getAllSelectableItems = (
  items: Omit<IMenuItem, 'prices'>[],
  optionGroup?: IOptionGroup,
): IOptionGroupItem[] => {
  const allModifiers: IOptionGroupItem[] = [
    ...items.map(
      (item: Omit<IMenuItem, 'prices'>): IOptionGroupItem => ({
        optionItemId: item.itemId,
        name: item.name,
        posId: item.plu,
        parentItemId: item.parentItemId,
        ranges: item.ranges,
      }),
    ),
    ...(optionGroup ? optionGroup.items : []),
  ];

  const uniqueModifiers = new Map<string, IOptionGroupItem>();
  allModifiers.forEach((modifier) => {
    if (!uniqueModifiers.has(modifier.optionItemId)) {
      uniqueModifiers.set(modifier.optionItemId, modifier);
    }
  });

  return Array.from(uniqueModifiers.values()).sort((first, second) => first.name.localeCompare(second.name));
};
